import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { getMyCourses } from "../../api";
import { Course } from "../../types";
import LearnCard from "./card";
import CourseCard from "../course-list/card";
import LearningIcon from "../../icons/learning";
import RecommendIcon from "../../icons/recommend";
import { Button, Loading } from "@quark/design";
import Navigator from "../../component/navigator";
import { useNavigate } from "react-router-dom";
import { getUserInfo } from "../../api";
import Footer from "../../component/footer";
import useDocumentTitle from "../../hooks/use-document-title";

const Home = () => {
  useDocumentTitle("课程列表");
  const navigate = useNavigate();
  const [courses, setCourses] = useState<Course[]>([]);
  const [recommendCourses, setRecommendCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(false);

  const queryData = () => {
    setLoading(true);
    Promise.all([getUserInfo(), getMyCourses()])
      .then(([userInfo, { my_courses, recommend_courses }]) => {
        if (!userInfo.is_login) {
          // dirty
          if (import.meta.env.PROD) {
            window.location.href = "/home";
          } else {
            alert("未登录，跳转至网站首页，调试模式下 alert 提示");
          }
          return;
        }
        if (!my_courses.length) {
          navigate("/course/list");
          return;
        }
        setCourses(my_courses);
        setRecommendCourses(recommend_courses);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    queryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gotoCourseList = () => {
    navigate("/course/list");
  };

  return (
    <div className={styles.container}>
      <Navigator />
      {loading && <Loading style={{ height: "100vh" }} />}
      {!loading && (
        <>
          <div className={styles.learning}>
            <div className={styles.title}>
              <LearningIcon />
              学习课程
            </div>
            <div className={styles.cards}>
              {courses.map((course) => (
                <LearnCard dataSource={course} key={course.id} />
              ))}
            </div>
            {!loading && !courses.length && <div>暂无课程</div>}
            <div className={styles.footer}>
              <Button onClick={gotoCourseList}>更多课程</Button>
            </div>
          </div>

          <div className={styles.recommend}>
            <div className={styles.title}>
              <RecommendIcon />
              推荐课程
            </div>
            <div className={styles.cards}>
              {recommendCourses.map((course) => (
                <CourseCard dataSource={course} key={course.id} />
              ))}
            </div>
          </div>
        </>
      )}
      <Footer />
    </div>
  );
};

export default Home;
